import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  historicTitle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
    textTransform: 'capitalize',
    color: '#333333',
  },
  historicSubtitle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
    color: '#828282',
  },
  historicDescription: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '10px',
    lineHeight: '14px',
    border: '1px dotted #DF0C36',
    borderRadius: '5px',
    overflowWrap: 'anywhere',
    maxHeight: 55,
    color: '#666666',
    marginTop: 5,
    padding: 5,
  },
  paper: {
    minWidth: '50%',
    height: '70%',
  },
  missingOppositeContent: {
    '&:before': {
      display: 'none',
    },
  },
  dialogContent: {
    padding: '20px',
  },
  timelineDotOutline: {
    border: '3px solid #DF0C36',
    backgroundColor: '#ffffff',
  },
  timelineDotContained: {
    border: '3px solid #DF0C36',
    backgroundColor: '#DF0C36',
  },
  timelineDisabled: {
    border: '3px solid #CCCCCC',
    backgroundColor: '#CCCCCC',
  },
  timelineConnector: {
    maxHeight: 90,
    backgroundColor: '#DF0C36',
  },
  container: {
    display: 'flex',
  },
  removeButton: {
    color: '#DF0C36',
    padding: '3px 0px',
    cursor: 'pointer',
    margin: '0px 10px',
  },
}));
